import errorLogger, {
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';

import { getContext } from '@/context';
import { setAppStore } from '@/store';

import type { CreditInfo } from '@/types';

const logWarning = (error: unknown) =>
  errorLogger.trigger(error as Error, BUGSNAG_STATUSES.WARN);

/**
 * Re-fetch the balance and keep it on the store, where the credit displays read
 * it. The SDK `credits` model can't be used for that: only a host push writes
 * it, and native hosts push at bootstrap only, so it stays stale for the session.
 */
const refreshMonetization = (): void => {
  try {
    getContext()
      .monetization.updateCredits()
      .then((fresh) => {
        const creditsInfo = fresh as unknown as CreditInfo | undefined;
        if (typeof creditsInfo?.credits !== 'number') return;
        setAppStore({ creditsInfo });
      })
      .catch(logWarning);
  } catch (error) {
    logWarning(error);
  }
};

export default refreshMonetization;
